import { memo, useContext } from "react";

import appStyles from "../../../App.module.css";
import { formatDate } from "../../../app-constants";
import { CorporateGroupTravelContext } from "../../CorporateGroupTravel";
import { ICorporateGroupTravelContext } from "../../config/interfaces";

const CGTripSummary = () => {
  const { quoteData } = useContext(CorporateGroupTravelContext) as ICorporateGroupTravelContext;
  return (
    <div className={`${appStyles.tripSummary} ${appStyles.CGTTripSummaryWarp}`}>
      <div className={appStyles.tripSummaryTitle}>
        <h4>Trip Information</h4>
      </div>

      <div className={appStyles.tripSummaryRow}>
        <div>Trip Duration</div>
        <div className={appStyles.tripSummaryValue}>
          {`${formatDate(quoteData.startDate)} to
            ${formatDate(quoteData.endDate)}`}
        </div>
      </div>

      <div className={appStyles.tripSummaryRow}>
        <div>Destination(s)</div>
        <div className={appStyles.tripSummaryValue}>
          {quoteData?.destinationCountries?.map((dest: any) => dest?.name).join(", ")}
        </div>
      </div>

      <div className={appStyles.tripSummaryRow}>
        <div>Number of Travelers</div>
        <div className={appStyles.tripSummaryValue}>{quoteData?.numberOfTravellers}</div>
      </div>
    </div>
  );
};

export default memo(CGTripSummary);
